import { useQuery } from '@tanstack/react-query'
import type { ISpRewardBrand } from '@brushfire/types'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import { queryKeys } from '@/api/query-keys'

export function useSpRewardBrands(search?: string) {
  return useQuery({
    queryKey: queryKeys.spRewards.brands(search),
    queryFn: async () => {
      const { data } = await apiClient.get<ApiResponse<ISpRewardBrand[]>>(
        '/api/v1/sp/rewards/brands',
        { params: search ? { q: search } : undefined },
      )
      return data.data
    },
  })
}
